import { format } from 'date-fns/format';
import { ptBR } from 'date-fns/locale/pt-BR';
import { RealizationEvItem } from 'types/realization';
import { BiSolidTrash } from 'react-icons/bi';
import Radio from '../Radio';
import { GrDownload } from 'react-icons/gr';
import { FaPlay } from 'react-icons/fa6';
import { Tooltip } from 'react-tooltip';
import { parseISO } from 'date-fns';
import { useModal } from 'context/ModalContext/Modal.context';
import { getConfirmedPlayers, getPlayerslist } from 'services/realization.service';
import { useEffect, useState } from 'react';
import ModalParticipantsEvaluation from '../Card/Modal/Evaluation';

interface Options {
    data: RealizationEvItem;
    allowRemove?: boolean;
    onSelect: (val: RealizationEvItem) => void;
    onEvaluation: (val: RealizationEvItem, option: string) => void;
    selectedEvaluations?: Array<{ realizationId: string; evaluation: string }>;
    onRemove: (val: RealizationEvItem) => void;
    qtdEvaluation: number;
    showOptions: boolean;
}

const CardEvaluation = ({ data, allowRemove, onSelect, onEvaluation, selectedEvaluations, onRemove, qtdEvaluation, showOptions }: Options) => {
    const { showModal } = useModal();
    const [confirmedPlayerList, setConfirmedPlayerList] = useState<any>([]);

    const canOption = (data: RealizationEvItem, evaluationType: string) => {
        const exists = selectedEvaluations?.find((ev) => ev.evaluation === evaluationType);
        return exists ? true : false;
    };

    async function getConfirmedList(idRealization: string) {
        const list = await getConfirmedPlayers(idRealization);
        const response = await getPlayerslist(idRealization);
        data.realization.team_data = response.team_data;
        const confirmedPlayers = list.confirmados.filter((id: string) => 
            response.team_data.some((player: any) => player.chave === id)
        );

        list.confirmados = confirmedPlayers
        setConfirmedPlayerList(list);
    }

    useEffect(() => {
        getConfirmedList(data.id_realizacao);
    }, [data]);

    const getTooltipMessage = (type: string) => {
        const messages: Record<string, string> = {
            relevant: 'Uma realização já foi avaliada como Relevante.',
            very: 'Uma realização já foi avaliada como Muito Relevante.',
            extremaly: 'Uma realização já foi avaliada como Extremamente Relevante.'
        };

        return messages[type] || 'Opção indisponível.';
    };

    const viewParticipants = () => {
        showModal(
            'view-participants',
            <ModalParticipantsEvaluation
                documento={data.documento}
                inscricao_mat={data.inscricao_mat}
                inscricao_name={data.inscricao_name}
                owner={data.owner}
                owner_name={data.owner_name}
                category={data.categoria}
                data={data.realization}
                confirmedPlayerList={confirmedPlayerList}
            />,
            'participants'
        );
    };

    return (
        <article className={`flex flex-col card ${allowRemove ? 'mb-12' : ''}`}>
            {!allowRemove && (
                <div className="mb-4 field md:mb-0">
                    <label>
                        <input type="radio" name="participant" onChange={(e) => onSelect(data)} /> Selecionar realização
                    </label>
                </div>
            )}

            <div className={`flex ${allowRemove ? 'md:justify-between flex-col-reverse md:flex-row gap-4' : 'md:justify-end'}`}>
                <div className="justify-start tag md:justify-end">{data.categoria && <span>{String(data.categoria)}</span>}</div>
                {allowRemove && qtdEvaluation > 3 && (
                    <div className="flex justify-end">
                        <button className="flex items-center gap-2 text-xs font-bold uppercase md:text-sm text-blue-bb-2" onClick={() => onRemove(data)}>
                            Remover realização <BiSolidTrash color={'#3354FD'} size={18} />
                        </button>
                    </div>
                )}
            </div>

            <h2 className="mt-3 mb-2 text-lg font-medium font-bb text-black-bb">
                <strong>Realização: </strong>
                {data.title}
            </h2>

            <div className="flex-1 p-4 detail bg-gray-bb-3">
                <p className="text-sm font-bold text-black-bb">
                    <strong>Inscrita por: </strong>
                </p>
                <p>
                    {data.inscricao_name} ({data.inscricao_mat}), em{' '}
                    {data.dt_aceite
                        ? format(typeof data.dt_aceite === 'string' ? parseISO(data.dt_aceite) : new Date(data.dt_aceite), "dd 'de' MMMM 'de' yyyy", {
                              locale: ptBR
                          })
                        : 'Data inválida'}
                </p>
                <p className="text-sm font-bold text-black-bb">
                    <strong>Cadastrado por: </strong>
                </p>
                <p>
                    {data.owner_name} ({data.owner})
                </p>
                <p className="mt-4 text-sm font-bold text-black-bb">
                    <strong>Detalhes da realização</strong>
                </p>
                <p dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>

            {!!data.documento && data.documento.length > 0 ? (
                <>
                    <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                        <strong>Documentação complementar da realização</strong>
                    </p>
                    {data.documento.map((item) => (
                        <>
                            {!!item && item !== null && (
                                <>
                                    {item.type === 'video' ? (
                                        <div className="relative mt-6">
                                            <div>
                                                <button>
                                                    <a
                                                        href={item.file}
                                                        className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <FaPlay />
                                                        Ver vídeo
                                                    </a>
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="mt-6">
                                            <button
                                                className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                                                onClick={() => {
                                                    window.open(item.file, '_blank');
                                                }}
                                            >
                                                <GrDownload size={22} />
                                                Download
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ))}
                    <div className="flex flex-col items-center justify-center gap-4 mt-4">
                        <button className="px-4 py-3 font-bold uppercase text-blue-bb" onClick={viewParticipants}>
                            Ver mais{' '}
                        </button>
                    </div>
                </>
            ) : (
                <></>
            )}

            {allowRemove && showOptions ? (
                <>
                    <div className="mt-4">
                        <h4 className="text-sm text-black-bb">Como você avalia esta realização?</h4>
                        <div className="flex flex-col gap-4 mt-4 md:flex-row md:mt-0 ">
                            {['relevant', 'very', 'extremaly'].map((option) => {
                                const isDisabled = canOption(data, option);
                                const isSelected = selectedEvaluations?.find((ev) => ev.realizationId === data._id)?.evaluation === option;

                                return (
                                    <div key={option} data-tooltip-id={!isSelected && isDisabled ? `tooltip-${option}` : undefined} data-tooltip-place="top">
                                        <Radio
                                            name={`evaluation-${data._id}`}
                                            checked={selectedEvaluations?.find((ev) => ev.realizationId === data._id)?.evaluation === option}
                                            onChange={() => onEvaluation(data, option)}
                                            label={option === 'relevant' ? 'Relevante' : option === 'very' ? 'Muito Relevante' : 'Extremamente Relevante'}
                                            disabled={isDisabled}
                                        />
                                        {!isSelected && isDisabled && <Tooltip id={`tooltip-${option}`} content={getTooltipMessage(option)} />}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            ) : (
                <></>
            )}
        </article>
    );
};

export default CardEvaluation;
